// extracted by mini-css-extract-plugin
export var borderRadius = "_57-4";
export var large = "_57-3";
export var logoContainer = "_57-0";
export var nameLogo = "_57-2";
export var small = "_57-1";